import { BasketDiscountType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

export const basketDiscountTypeOptions: { [key in BasketDiscountType]: string } = {
  [BasketDiscountType.AMOUNT]: 'campaigns.discount-type.options.amount',
  [BasketDiscountType.PERCENTAGE]: 'campaigns.discount-type.options.percentage',
};
